<template>
    <vs-popup :active.sync="isActive"  title="Kasaya Nakit Girişi">
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
<h3>Lütfen kasaya eklenecek olan tutarı giriniz.</h3>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" class="mt-4">
           <vs-input class="w-full" id="Nakit" name="Nakit" v-validate="'required'" v-model="price" label-placeholder="Kasaya Eklenecek Tutar: " @input="handleInput">
                
            </vs-input>
            <span class="text-danger text-sm" v-show="errors.has('Nakit')">{{ errors.first('Nakit') }}</span>
        </vs-row>

        <vs-row vs-type="flex" vs-w="12" class="mt-4">
           <vs-input class="w-full" id="Aciklama" name="Aciklama" v-validate="'required'" v-model="description" label-placeholder="Açıklama: " >
                
            </vs-input>
            <span class="text-danger text-sm" v-show="errors.has('Aciklama')">{{ errors.first('Aciklama') }}</span>
        </vs-row>
        
          <vs-row vs-type="flex" vs-w="12" class="mt-4">
            
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
              <vs-button @click="showPopup" size="large" color="transparent" class="bold bg-success text-white ml-2">
                Onayla
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-row>
        
      <div class="popup-overlay" v-if="showPopupFlag">
        <div class="popup">
          <h3>Kaydetmek istediğinize emin misiniz?</h3>
          <div class="popup-actions">
            <vs-button color="success" type="filled" class="px-6 bold" @click="forcelose">Kaydet</vs-button>
            <vs-button color="danger" type="filled" class="px-6 bold" @click="closePopup">İptal</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </template>
  
  <script>
  import {
    createSafeCashEntry
  } from "@/api/SafeCashEntry.js";
  import companyInfo from "../../../model/constants/companyInfo";
  export default {
    data() {
      return {
        isActive: false, // Pop-up'ı başlangıçta açık tutmak için
        logo: companyInfo.logo,
        showPopupFlag: false,
        price: 0,
        description: ''
      };
    },
    computed:{
      activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    }
    },
    watch:{
        isActive(val) {
          this.price = 0,
          this.description = '';
        }
    },
    methods: {
        handleInput() {
      // Girilen değeri kontrol et
      if (this.price !== null) {
        // Sayı ve en fazla iki ondalık basamak kontrolü
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.price)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.price = this.price.slice(0, -1); // En son karakteri siler
        }
      }
    },
    handleInputForX() {
      // Girilen değeri kontrol et
      if (this.price !== null) {
        // Sayı ve en fazla iki ondalık basamak kontrolü
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.price)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.price = this.price.slice(0, -1); // En son karakteri siler
        }
      }
    },
        showPopup: async function () {
          let checker = await this.$validator.validateAll(); 
         if (!checker) {
          return;
         }
        this.showPopupFlag = true
      },
        closePopup() {
        this.showPopupFlag = false;
      },
        forcelose: async function () {
            createSafeCashEntry({price: this.price, description: this.description, userId: this.activePersonel.id, userName:this.activePersonel.name }).then(res =>{
                if (res && res.status == 200) {
                    this.$vs.notify({
            color: 'success',
            title: 'Kasaya nakit ekleme başarılı',
            text: 'Kasaya nakit ekleme başarılı !'
          });
         // this.$emit("emitDisable", true);
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ödeme Raporu Yüklenemedi !'
            });
          }
            }).catch(error => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
            this.showPopupFlag = false;
            this.isActive = false;
        },
      preventCloseOnClick() {
        // İhtiyaca göre özel mantık ekleyebilirsiniz
      },
      handlePopupUpdate(newValue) {
      // Pop-up durumu güncellendiğinde tetiklenir
      if (!newValue) {
        // Pop-up kapatıldığında yapılacak işlemler
        this.isActive = true; // Pop-up'ı tekrar açmak için
      }
    },
    },
  };
  </script>
  <style>
  
  .logo{
    background-color: white;
       border-radius: 10px;
    margin-bottom: 1rem;
  }
  #switchScreen{
    z-index: 999999;
  }
  #switchScreen .vs-popup .vs-popup--header {
    display: none !important;
  }
  
  #switchScreen .vs-popup .vs-popup--content {
    padding: 0 !important;
    /*height: 47vh;*/
  }
  
  #switchScreen .vs-popup {
    background: transparent !important;
    box-shadow: none !important;
  }
  
  #switchScreen input {
    font-size: 2rem !important;
    background: #f2f2f2 0% 0% no-repeat padding-box !important;
    text-align: center !important;
    padding: 0.5rem;
  }

  .popup-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    border-radius: 6px;
  }
  .popup-overlay .popup {
    background: #fff;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
    text-align: center;
    max-width: 90%;
  }
  .popup-overlay .popup h3 {
    margin-bottom: 1.5rem;
    color: #2c2c2c;
    font-size: 1.15rem;
    font-weight: 600;
  }
  .popup-overlay .popup-actions {
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  </style>
  